import { render, staticRenderFns } from "./caterDishOrderInfo.vue?vue&type=template&id=91f5b85a&scoped=true&"
import script from "./caterDishOrderInfo.vue?vue&type=script&lang=js&"
export * from "./caterDishOrderInfo.vue?vue&type=script&lang=js&"
import style0 from "./caterDishOrderInfo.vue?vue&type=style&index=0&id=91f5b85a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91f5b85a",
  null
  
)

export default component.exports